import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, ExcludeSpecialCharactersFromInputTypeNumber } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider, Box } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import appFetch from '../../../../api/appFetch.js';
import ChecklistTemplateDropdown from '../../../Common/Dropdowns/ChecklistTemplateDropdown.js';
import { BookingItemsUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import BrandsDropdown from '../../../Common/Dropdowns/BrandsDropdown.js';
import LanguageDropdown from '../../../Common/Dropdowns/LanguageDropdown.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';

export default class BookingItemsCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            objectType: this.props.objectType !== undefined ? parseInt(this.props.objectType) : null,
            outletId: this.props.outletId !== undefined ? parseInt(this.props.outletId) : 0,
            language: this.props.language !== undefined ? this.props.language : "nl",
            description: "",
            isVisibleInPlanning: false,
            shortDescription: "",
            validFrom: "",
            validTill: "",
            brandId: 0,
            operationCode: "",
            price: null,
            laborTime: null,
            infoURL: "",
            isMaintenance: false,
            isB2CVisible: false,
            isQuoteItem: false,
            isKeyDropVisible: false,
            isCheckInUpselling: false,
            checkedForData: false,
            selectedOutletId: 0,
            loading: false,
            redirect: null,
            accessibleMoboOutlets: [],
            requestInProgress: false,
            open: true,
            bookingItemsWasCreated: false,
            checklistTemplateId: 0
        };
    }

    componentDidMount() {
        if (this.props.accessibleMoboOutlets === undefined) {
            return;
        }

        if (this.props.outletId === undefined) {
            this.setState({ outletId: 0 });
        }
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/bookingitems" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") }, () => this.handleValidation());
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked }, () => this.handleValidation());
    };

    handleValidation = () => {
        // this.setState({ requestInProgress: !this.checkIfRequestIsValid(false) });
    }

    checkIfRequestIsValid(displayErrorMessage) {
        let resources = this.props.resources;
        var isValidRequest = true;

        if (this.state.shortDescription.trim().length <= 0) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidShotDescription"], "error");
            isValidRequest = false;
        }

        if (this.state.validFrom === "" || this.state.validFrom === undefined) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidDateFrom"], "error");
            isValidRequest = false;
        }
        if (this.state.validTill === "" || this.state.validTill === undefined) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidDateTill"], "error");
            isValidRequest = false;
        }

        if (displayErrorMessage && this.state.validFrom > this.state.validTill) {
            DisplayMessage(resources["InvalidDateTill"], "error");
            isValidRequest = false;
        }

        if (displayErrorMessage && this.state.laborTime !== null && this.state.laborTime < 0) {
            DisplayMessage(resources["InvalidLaborTime"], "error");
            isValidRequest = false;
        }

        if (this.state.price !== null && this.state.price !== undefined) {
            var filterPrice = /^\d{0,4}(\.\d{1,2})?$/;
            var isValidPrice = filterPrice.test(this.state.price);
            if (displayErrorMessage && !isValidPrice) DisplayMessage(resources["InvalidPrice"], "error");

            isValidRequest = isValidPrice;
        }

        return isValidRequest;
    }

    isValidForm = () => {
        const { shortDescription, validFrom, validTill, laborTime, price } = this.state

        if (!shortDescription || shortDescription.trim().length === 0) {
            return false;
        }

        if (!validFrom) {
            return false;
        }

        if (!validTill) {
            return false;
        }

        const momentValidFrom = moment(validFrom, "YYYY/MM/DD");
        const momentValidTill = moment(validTill, "YYYY/MM/DD");

        if (!momentValidFrom.isValid() || !momentValidTill.isValid() || momentValidTill.isBefore(momentValidFrom)) {
            return false;
        }

        if (laborTime && laborTime < 0) {
            return false;
        }

        const priceRegex = /^\d{0,4}(\.\d{1,2})?$/

        if (price && !priceRegex.test(price)) {
            return false;
        }

        return true;
    }

    handleSubmit = () => {
        this.saveNewBookingItems();
    }

    saveNewBookingItems = () => {
        this.setState({ requestInProgress: true });
        let resources = this.props.resources;

        if (!this.checkIfRequestIsValid(true)) {
            return;
        }

        const { outletId, brandId, language, shortDescription, longDescription, validFrom, validTill, price, operationCode, laborTime, isMaintenance, isB2CVisible, isQuoteItem, infoURL, isKeyDropVisible, isCheckInUpselling, checklistTemplateId } = this.state;

        var json = JSON.stringify({
            moboOutletId: outletId === 0 ? null : outletId,
            brandId: brandId === 0 ? null : brandId,
            language: language,
            shortDescription: shortDescription,
            longDescription: longDescription,
            validFrom: validFrom,
            validTill: validTill,
            price: price !== null ? parseFloat(price) : null,
            operationCode: operationCode,
            laborTime: laborTime !== null ? parseInt(laborTime) : null,
            isMaintenance: isMaintenance,
            isB2CVisible: isB2CVisible,
            isQuoteItem: isQuoteItem,
            isKeyDropVisible: isKeyDropVisible,
            isCheckInUpselling: isCheckInUpselling,
            infoURL: infoURL === "" ? null : infoURL,
            checklistTemplateId: checklistTemplateId === 0 ? null : checklistTemplateId,
        });

        const url = BookingItemsUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (response) => {
                if (response.id !== undefined) {
                    this.setState({
                        updateInProgress: false,
                        bookingItemsWasCreated: true,
                        redirect: "/bookingitems"
                    });

                    DisplayMessage(resources["BookingItemsWasSaved"], "success");
                }
            },
            onError: (response) => {
                for (var i = 0; i < response.errors.length; i++) {
                    DisplayMessage(response.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleChangeOutlet = e => {
        const selectedOutletId = parseInt(e.target.value);
        const selectedOutlet = this.props.accessibleMoboOutlets?.find(outlet => outlet.id === selectedOutletId);
        const objectTypeValue = selectedOutlet ? selectedOutlet.objectType : null;
    
        this.setState({ outletId: selectedOutletId, objectType: objectTypeValue, brandId: 0 });
    };

    handleValidFrom = value => {
        this.setState({ validFrom: value }, () => this.handleValidation());
    };

    handleValidTill = value => {
        this.setState({ validTill: value }, () => this.handleValidation());
    };

    handleChangeBrand = e => {
        this.setState({ brandId: parseInt(e.target.value) });
    };

    handleChangeChecklistTemplate = e => {
        this.setState({ checklistTemplateId: parseInt(e.target.value) });
    };

    handleChangeNumber = e => {
        const numberRegex = /^(0|[1-9]\d{0,3})?(\.\d{1,2})?$/
        if (numberRegex.test(e.target.value.toString())) {
            this.setState({ [e.target.name]: e.target.value }, () => this.handleValidation());
        }
    };

    renderForm() {
        const { validFrom, validTill, isMaintenance, isB2CVisible, isQuoteItem, brandId,
            operationCode, price, laborTime, outletId, language, shortDescription, longDescription,
            infoURL, isKeyDropVisible, isCheckInUpselling, checklistTemplateId, objectType } = this.state;
        var resources = this.props.resources;

        var helperTextShortDescription = shortDescription.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <BrandsDropdown
                            resources={resources}
                            brand={brandId}
                            objectType={objectType}
                            onBrandChange={this.handleChangeBrand}
                            containerClass="col-6 helper-text-red"
                            onRequestStart={() => this.setState({ requestInProgress: true })}
                            onRequestEnd={() => this.setState({ requestInProgress: false })}
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <LanguageDropdown
                            resources={resources}
                            language={language}
                            onLanguageChange={this.handleChange}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className=" d-flex" >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextShortDescription} id="bookingitems-shortDescription"
                                value={shortDescription} label={resources["ShortDescription"]}
                                helperText={resources["InputOfShortDescriptionIsMandatory"]}
                                variant="outlined" name="shortDescription" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 " id="bookingitems-longDescription"
                                value={longDescription} label={resources["LongDescription"]}
                                variant="outlined" name="longDescription" onChange={this.handleChange} inputProps={{ maxLength: 200 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <Box display="flex" justifyContent="space-between" className='col-6' padding="0" gap="15px">
                            <DatePickerComponent
                                id="dateValidFrom"
                                label={resources["ValidFrom"]}
                                value={validFrom}
                                onChange={this.handleValidFrom}
                                error={!validFrom}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            
                            />
                            <DatePickerComponent
                                id="dateValidTill"
                                label={resources["ValidTill"]}
                                value={validTill}
                                onChange={this.handleValidTill}
                                error={!validTill}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                        </Box>
                    </Form.Group>

                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-operationCode"
                                value={operationCode} label={resources["OperationCode"]}
                                variant="outlined" name="operationCode" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-price"
                                value={price} label={resources["Price"]}
                                variant="outlined" name="price" onChange={this.handleChangeNumber} type="number"
                                onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(false)}
                                inputProps={{
                                    maxLength: 6,
                                    min: 0,
                                    step: "0.01",
                                }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-laborTime"
                                value={laborTime} label={resources["LaborTime"]}
                                variant="outlined" name="laborTime" onChange={this.handleChangeNumber} type="number"
                                onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(true)}
                                InputProps={{ inputProps: { min: 0 } }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-infoURL"
                                value={infoURL} label={resources["InfoURL"]}
                                variant="outlined" name="infoURL" onChange={this.handleChange}
                            />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ChecklistTemplateDropdown
                            resources={resources}
                            checklistTemplateId={checklistTemplateId}
                            onChecklistTemplateChange={this.handleChangeChecklistTemplate}
                            containerClass="col-6 helper-text-red text-left"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isMaintenance" checked={isMaintenance} onChange={this.handleChangeCheckBox} name="isMaintenance" color="primary" />}
                            label={resources["IsMaintenance"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isB2CVisible" checked={isB2CVisible} onChange={this.handleChangeCheckBox} name="isB2CVisible" color="primary" />}
                            label={resources["IsB2CVisible"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isQuoteItem" checked={isQuoteItem} onChange={this.handleChangeCheckBox} name="isQuoteItem" color="primary" />}
                            label={resources["IsQuoteItem"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isKeyDropVisible" checked={isKeyDropVisible} onChange={this.handleChangeCheckBox} name="isKeyDropVisible" color="primary" />}
                            label={resources["IsKeyDropVisible"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isCheckInUpselling" checked={isCheckInUpselling} onChange={this.handleChangeCheckBox} name="isCheckInUpselling" color="primary" />}
                            label={resources["IsCheckInUpselling"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, bookingItemsWasCreated, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;
        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: bookingItemsWasCreated, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-new-bookingitems" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["NewBookingItems"]}
                            </Typography>
                            <Button id="bookingitems-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}